module.exports = __webpack_public_path__ + "static/media/en-us.0d35573b.png";